import { atom } from 'recoil';

type ApplicationErrorDialog = {
  isOpen: boolean;
};

// アプリケーションエラーダイアログは閉じた状態を初期値にし、初回表示で誤って開かないようにする。
const applicationErrorDialogState = atom<ApplicationErrorDialog>({
  key: 'applicationErrorDialog',
  default: {
    isOpen: false,
  },
});

export default applicationErrorDialogState;
